"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mobileNavigationHeight = exports.MobileNavWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components")); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var mobileNavigationHeight = '4.5rem';
exports.mobileNavigationHeight = mobileNavigationHeight;

var MobileNavWrapper = /*#__PURE__*/_styledComponents["default"].nav.withConfig({
  displayName: "indexstyles__MobileNavWrapper",
  componentId: "sc-4g0oan-0"
})(["position:fixed;bottom:0;left:0;z-index:3;display:flex;justify-content:space-between;align-items:stretch;width:100%;height:", ";border-top:1px solid ", ";background-color:", ";box-shadow:0 0 10px 2px ", ";"], mobileNavigationHeight, function (p) {
  return p.theme.tokens.colorBackground;
}, function (p) {
  return p.theme.tokens.colorBackground;
}, function (p) {
  return p.theme.tokens.colorPaletteGray400;
});

exports.MobileNavWrapper = MobileNavWrapper;